import { Component } from 'react'
import { withRouter } from 'react-router'
import classnames from 'classnames'
import { get } from 'lodash'
import { getHistory } from 'lib/history'

import * as blUrls from 'lib/urls'
import NavBar from '../navbar'
import MobileSearchBar from '../mobile-search-bar'
import { tracking } from 'lib/analytics'

const history = getHistory({ useRouter: true })

@tracking()
class AppContainer extends Component {
  componentDidMount() {
    // listen for other parts of our site (mobile nav) to trigger route changes
    PubSub.subscribe(BLConstants.ROUTE_CHANGE, (path) => {
      this.props.router.push(path)
    })
  }

  render() {
    // iPad adds an extra trailing slash to the the path - check for both
    const isLandingPage =
      this.props.location.pathname &&
      this.props.location.pathname.replace(/\/$/, '') == blUrls.storePath
    const isPDP =
      this.props.location.pathname &&
      this.props.location.pathname.search(/\/gp\//i) >= 0

    // TODO this logic is duplicated in the side-nav. consolidate it to a single place
    let activeSlugSet =
      (this.props.location.state && this.props.location.state.slugSet) || []
    if (!activeSlugSet.length && get(this.props, 'params.categorySlug')) {
      activeSlugSet =
        this.props.categories[this.props.params.categorySlug].slugSet
    }

    return (
      <div>
        <NavBar
          searchText={this.props.searchText}
          categoryTree={this.props.categoryTree}
          activeSlugSet={activeSlugSet}
          history={history}
          affix={!isPDP}
        />
        <MobileSearchBar />
        {
          // Setting a minHeight on this container so that the footer does not come
          // into view when the animation is happening.
        }
        <div
          className={classnames({ container: !isLandingPage && !isPDP })}
          style={{ minHeight: 'calc(100vh)' }}
        >
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default withRouter(AppContainer)
